import { Injectable } from '@angular/core';
import { Router, Route } from '@angular/router';
import { CurrentUserService } from '../../security/services/CurrentUserService';
import { AppConfigurationService } from './AppConfigurationService';

@Injectable()
export class RootNavigationManager {
  constructor(public router: Router,
    private currentUserService: CurrentUserService,
    private appConfigurationService: AppConfigurationService) {
  }

  public getActiveRoutes(): Route[] {
    return this.router.config.filter(r => r.data && r.data.title && r.data.isNav && this.currentUserService.hasPermission(r.data.permissions));
  }

  public getNavigationActiveRoutes(): Route[] {
    return this.getActiveRoutes().filter(r => r.data.title );
  }

  public goHome(): void {
    this.goToPath();
  }

  public goToPath(path?: string): void {
    path = path || this.appConfigurationService.configuration.defaultHome;
    var activeRoutes = this.getActiveRoutes();
    if (!activeRoutes || activeRoutes.length === 0) {
      this.router.navigateByUrl('/' + path);
      return;
    }
    var route = activeRoutes.find(r => this.matchPath(r.path, path));
    if (!route && activeRoutes.length > 0) {
      route = activeRoutes.find(r => r.data && r.data.title);
    }
    if (route) {
      this.router.navigateByUrl('/' + path );
    } else {
      this.goToLanding();
    }
  }

  public matchPath( routePath: string, requestedPath: string): boolean {
    var rootPath = routePath.split('/', 1)[0];
    return requestedPath.replace('/', '').startsWith(rootPath);
  }

  public goToLanding(): void {
    this.router.navigateByUrl('/public');
  }

  public isLandingPage(path: string): boolean {
    return path === 'public' || path === '/public';
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/RootNavigationManager.ts